import { ISource } from 'entities/Source/model/types';

export interface IOnboardingState {
	modalIsOpened: boolean;
	state: EOnboardingStates;
	step: EOnboardingSteps;
	createdSource: ISource | null;
	resultType: EResultTypes;
}

export enum EOnboardingStates {
	WELCOME = 'welcome',
	STEPS = 'steps',
	FINAL = 'final',
}

export enum EOnboardingSteps {
	FIRST = 1,
	SECOND = 2,
	THIRD = 3,
}

export enum EResultTypes {
	SUCCESS = 'success',
	NEED_VERIFICATION = 'need_verification',
	NEED_SOURCE = 'need_source',
}
